import { Button, DefaultTheme, Select, ThemeProps } from "@deliverr/ui";
import { ModalTemplate } from "@deliverr/ui-facility";
import styled from "@emotion/styled";
import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { useSortationModal } from "sortation/components/SortationModal";
import { MiddleMilePartner } from "@deliverr/sortation-client";
import { LoadToTrailerModal } from "./LoadToTrailerModal";

interface IProps {
  readonly bolId: string;
  readonly gaylordId: string;
  readonly tripId: string;
  readonly options: MiddleMilePartner[];
  readonly onConfirm: (partner: MiddleMilePartner) => void;
}

const ButtonContainer = styled.div<{}, DefaultTheme>`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.S3};
`;

const FormContainer = styled.div<ThemeProps>(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${theme.spacing.S2};
  margin-bottom: ${theme.spacing.S3};
  text-align: left;
`
);

export const MiddleMilePartnerSelectionModal: React.FC<IProps> = ({ bolId, gaylordId, tripId, options, onConfirm }) => {
  const { hideModal } = useSortationModal();
  const [partner, setPartner] = useState<MiddleMilePartner>();

  const partnerOptions = options.map((value) => ({ value, label: value }));

  const handlePartnerChange = (option: typeof partnerOptions[number]) => {
    setPartner(option.value);
  };

  const handleConfirm = () => {
    if (partner) {
      onConfirm(partner);
    }
  };

  return (
    <ModalTemplate
      buttonLayout={"column"}
      title={
        <FormattedMessage
          id="sortation.loadToTrailer.middleMilePartner.header"
          defaultMessage="Select Middle Mile Partner"
        />
      }
    >
      <FormContainer>
        <div>
          <strong>BOL ID:</strong> {bolId}
        </div>
        <div>
          <strong>Gaylord ID:</strong> {gaylordId}
        </div>
        <div>
          <strong>Booking ID:</strong> {tripId}
        </div>
        <Select
          label="Middle Mile Partner"
          value={partnerOptions.find((opt) => opt.value === partner)}
          options={partnerOptions}
          onChange={handlePartnerChange}
        />
      </FormContainer>

      <ButtonContainer>
        <Button block onClick={handleConfirm} disabled={!partner}>
          <FormattedMessage id="sortation.loadToTrailer.middleMilePartner.confirm" defaultMessage="Confirm" />
        </Button>
        <Button block onClick={() => hideModal(LoadToTrailerModal.MIDDLE_MILE_PARTNER_SELECTION)} secondary>
          <FormattedMessage id="sortation.loadToTrailer.middleMilePartner.cancel" defaultMessage="Cancel" />
        </Button>
      </ButtonContainer>
    </ModalTemplate>
  );
};
